export default {
    namespaced: true,
    state: () => ({
        ThongTinNhanVien: {
            HoTen: null,
            SoDienThoai: null,
            CCCD: null,
            IdDoanhNghiep: null,
        },
    }),
    getters: {},

    mutations: {
        Set: (state, { key, data }) => {
            state[key] = data;
        },
        Reset_ThongTinNhanVien: (state) => {
            state.ThongTinNhanVien = {
                HoTen: null,
                SoDienThoai: null,
                CCCD: null,
                IdDoanhNghiep: null,
            };
        },
    },

    actions: {
        LayDanhSachNhanVien(store, key) {
            store;
            let defaultData = {
                data: [],
                groupCount: 0,
                summary: [0],
                totalCount: 0,
            };
            var load = this.$Helper.Common.DevExDataSourceCustom(
                async (loadOptions) => {
                    this.startLoading();
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t("url.DanhSachNhanVien")
                        ).Post(loadOptions);

                        if (resp.Data.status) {
                            let data =
                                resp.Data.data && resp.Data.data.data
                                    ? resp.Data.data
                                    : defaultData;
                            return data;
                        } else return defaultData;
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    } finally {
                        this.stopLoading();
                    }
                },
                "IdNhanVien" || null,
                async (key) => {
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t("url.DanhSachNhanVien")
                        ).Post({
                            filter: ["IdNhanVien", "=", key],
                        });
                        if (resp.StatusCode === 200) {
                            let data =
                                (resp.Data.data?.data || []).length > 0
                                    ? resp.Data.data.data[0]
                                    : {};
                            return data;
                        } else {
                            return {};
                        }
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    }
                }
            );
            return load;
        },

        async TaoMoiNhanVien(store) {
            try {
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.TaoMoiNhanVien")
                ).Post(store.state.ThongTinNhanVien);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
        async CapNhatNhanVien(store) {
            try {
                let dataPost = {
                    IdNhanVien: store.state.ThongTinNhanVien.IdNhanVien,
                    HoTen: store.state.ThongTinNhanVien.HoTen,
                    SoDienThoai: store.state.ThongTinNhanVien.SoDienThoai,
                    CCCD: store.state.ThongTinNhanVien.CCCD,
                    IdDoanhNghiep: store.state.ThongTinNhanVien.IdDoanhNghiep,
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.CapNhatNhanVien")
                ).Put(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },

        async XoaNhanVien({ state }, IdNhanVien) {
            try {
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.NhanVien") + `/${IdNhanVien}`
                ).Delete();
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
    },
};
